import { BiMoneyWithdraw } from "react-icons/bi";
import { SiCivicrm } from "react-icons/si";
import { TfiMoney } from "react-icons/tfi";
import { GoPeople } from "react-icons/go";
import { CiMoneyBill } from "react-icons/ci";

const sidebar = [
  {
    titleKey: "nav.home",
    title: "Home",
    icon: <SiCivicrm />,
    link: '/purchases/home'
  },
  {
    titleKey: "sidebar.suppliers",
    title: "Suppliers",
    icon: <GoPeople />,
    link: '/purchases/suppliers',
    permission: 'purchases.suppliers.view'
  },
  {
    titleKey: "sidebar.purchaseOrders",
    title: "Purchase Orders",
    icon: <BiMoneyWithdraw />,
    link: '/purchases/purchase-orders',
    permission: 'purchases.orders.view'
  },
  {
    titleKey: "sidebar.bills",
    title: "Bills",
    icon: <CiMoneyBill />,
    link: '/purchases/bills',
    permission: 'purchases.bills.view'
  },
  {
    titleKey: "sidebar.payments",
    title: "Payments",
    icon: <TfiMoney />,
    link: '/purchases/payments',
    permission: 'purchases.payments.view'
  }
];

export default sidebar;
